<template>
    <div class="list_nav clearfix">
        <div class='list_nav_contain'>
            <div is="NavShowCarType"
                style="z-index: 11;"></div>
            <div is="NavBrand" class="nav_brand relative"
                style="z-index: 10;"></div>
            <div is="NavSeries" class="nav_series relative"
                style="z-index: 9;"></div>
            <div is="NavPrice" class="nav_price relative"
                clisk_type="sale-prices" style="z-index: 8;"></div>
            <div is="NavType" class="nav_type relative"
                clisk_type="sale-models" style="z-index: 7;"></div>
            <div is="NavAge" class="nav_age relative"
                click_type="sale-years" style="z-index: 6;"></div>
            <div is="NavDis" class="nav_dis relative"
                click_type="sale-mileages" style="z-index: 5;"></div>
            <div is="NavTransmission" class="nav_transmission relative" 
                click_type="sale-transmissions" style="z-index: 4;"></div>
            <div is="NavEngine" class="nav_engine relative" 
                click_type="sale-engines" style="z-index: 3;"></div>
            <div is="NavStandard" class="nav_standard relative" 
                click_type="sale-standard" style="z-index: 2;"></div>
            <div is="NavCountry" class="nav_country relative" 
                click_type="sale-country" style="z-index: 1;"></div>
            <div is="NavColor" class="nav_color relative" 
                click_type="sale-color" style="z-index: 0;"></div>
        </div>
    </div>
</template>

<script>
    import NavColor from './ListNav/NavColor.vue';
    import NavCountry from './ListNav/NavCountry.vue';
    import NavStandard from './ListNav/NavStandard.vue';
    import NavEngine from './ListNav/NavEngine.vue';
    import NavTransmission from './ListNav/NavTransmission.vue';
    import NavDis from './ListNav/NavDis.vue';
    import NavAge from './ListNav/NavAge.vue';
    import NavType from './ListNav/NavType.vue';
    import NavPrice from './ListNav/NavPrice.vue';
    import NavSeries from './ListNav/NavSeries.vue';
    import NavBrand from './ListNav/NavBrand.vue';
    import NavShowCarType from './ListNav/NavShowCarType.vue';
    export default {
        components: {
            NavColor,
            NavCountry,
            NavStandard,
            NavEngine,
            NavTransmission,
            NavDis,
            NavAge,
            NavType,
            NavPrice,
            NavSeries,
            NavBrand,
            NavShowCarType
        }
    };
</script>

<style lang="less" scoped>
    .relative {
        position: relative;
    }
</style>



// WEBPACK FOOTER //
// ListNav.vue?2341acb5